import { getCookie } from '../../utilities/CookieUtils'
import { addRule } from '@chrisjwarnes/form-validator/src'

function addGoogleAnalyticsTrackingToForms () {
  addRule('valGoogleAnalytics', function (field) {
    return {
      type: 'string',
      asyncValidator: (rule, value) => {
        return new Promise((resolve, reject) => {
          const gaTrackingId = getCookie('_ga')
          if (gaTrackingId) {
            value = gaTrackingId
            field.value = gaTrackingId
          }
          resolve()
        })
      }
    }
  })
}

export {
  addGoogleAnalyticsTrackingToForms
}
